export const removeMaskDocument = (document: string) => document.replace(/[^\w\s]/gi, '');
